import { jsx as _jsx } from "react/jsx-runtime";
import { AppLangCode } from '@libs/types';
import { CustomDepositWithdrawSteps } from './styles';
import { registrationImages, registrationImagesEng } from './index';
const RegistrationSteps = ({ selectedLanguageCode, storageLink, MobileFrameImage, containerWidth, registrationStepsTitlesArray = [], }) => {
    const registrationImg = selectedLanguageCode === AppLangCode.KA
        ? registrationImages
        : registrationImagesEng;
    return (_jsx(CustomDepositWithdrawSteps, { imagesArray: registrationImg, imagesArrayLength: registrationImages.length - 1, stepTitles: registrationStepsTitlesArray, storageLink: storageLink, MobileFrameImage: MobileFrameImage, containerWidth: containerWidth }));
};
export default RegistrationSteps;
//# sourceMappingURL=RegistrationSteps.js.map